module.exports = __webpack_public_path__ + "static/media/store_map.21a56a42.jpg";